// App.jsx
import React from 'react';
import '../styles/sdg-selection.css';
import SDGSelected from 'sdgselection/components/SdgSelected';

const SdgSelectedPage = () => {
  return (
    <div className="sdg-container">
      <SDGSelected />
    </div>
  );
};

export default SdgSelectedPage;
